module.exports = __webpack_public_path__ + "img/0.3c07b2b4.jpg";